import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

function getAppLinks(links, nativeApp) {
  return nativeApp ? (links || []).filter(link => link.type === nativeApp) : links;
}

const appLinksSelector = createSelector(
  get('settings.appLinks'),
  get('route.query.native-app'),
  getAppLinks
);

export default appLinksSelector;
